import { render } from "./MonitorsSingleScreen.vue?vue&type=template&id=6c2d23f5"
import script from "./MonitorsSingleScreen.vue?vue&type=script&lang=js"
export * from "./MonitorsSingleScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__